/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AddressDetails__AddressFragmentDoc } from '../addresses/Addresses.generated.js';
import { AttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../attachments/Attachments.generated.js';
import { CrmContactPersonFragmentDoc } from '../../auth/UserDataProvider.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateCrmCompanyMutationVariables = Types.Exact<{
  input: Types.CreateCrmCompanyInput;
}>;


export type CreateCrmCompanyMutation = { createCrmCompany: { __typename: 'CreateCrmCompanyResult', crmCompany: { __typename: 'CrmCompany', id: string, title: string, email: any, number: string, abcCategory: Types.CrmOrganisationAbcCategory, contactPerson?: { __typename: 'CrmPerson', id: string, fullname: string } | null, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }, customFields: Array<{ __typename: 'CustomFieldField', key: string, label: string, value: any }> } } };

export type CreateCrmCompanyAsIndividualMutationVariables = Types.Exact<{
  input: Types.CreateCrmCompanyAsIndividualInput;
}>;


export type CreateCrmCompanyAsIndividualMutation = { createCrmCompanyAsIndividual: { __typename: 'CreateCrmCompanyAsIndividualResult', crmCompany: { __typename: 'CrmCompany', id: string, title: string, email: any, number: string, abcCategory: Types.CrmOrganisationAbcCategory, contactPerson?: { __typename: 'CrmPerson', id: string, fullname: string } | null, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }, customFields: Array<{ __typename: 'CustomFieldField', key: string, label: string, value: any }> } } };

export type CreateCrmCompany_CrmCompanyFragment = { __typename: 'CrmCompany', id: string, title: string, email: any, number: string, abcCategory: Types.CrmOrganisationAbcCategory, contactPerson?: { __typename: 'CrmPerson', id: string, fullname: string } | null, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string }, customFields: Array<{ __typename: 'CustomFieldField', key: string, label: string, value: any }> };

export type ModifyCrmOrganisationMutationVariables = Types.Exact<{
  organisations: Array<Types.CrmOrganisationModifyInput>;
}>;


export type ModifyCrmOrganisationMutation = { modifyCrmOrganisation: { __typename: 'CrmOrganisationModifyResult', crmOrganisations: Array<{ __typename: 'CrmCompany', id: string, title: string, description: string, website: string, isMeister: boolean, email: any, contactPerson?: { __typename: 'CrmPerson', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, categories: Array<string> } | null, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } }> } };

export type OrganisationRouter__CrmCompanyFragment = { __typename: 'CrmCompany', id: string, title: string, description: string, website: string, isMeister: boolean, email: any, contactPerson?: { __typename: 'CrmPerson', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, categories: Array<string> } | null, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, logo: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } };

export const CreateCrmCompany_CrmCompanyFragmentDoc = gql`
    fragment CreateCrmCompany_CrmCompany on CrmCompany {
  id
  title
  email
  number
  abcCategory
  contactPerson {
    id
    fullname
  }
  billingAddress {
    ...AddressDetails__Address
  }
  logo {
    ...AttachmentSnapshot
  }
  customFields {
    key
    label
    value
  }
}
    ${AddressDetails__AddressFragmentDoc}
${AttachmentSnapshotFragmentDoc}`;
export const OrganisationRouter__CrmCompanyFragmentDoc = gql`
    fragment OrganisationRouter__CrmCompany on CrmCompany {
  id
  title
  description
  website
  isMeister
  contactPerson {
    id
    ...CrmContactPerson
  }
  email
  phones {
    id
    main
    type
    number
  }
  logo {
    ...AttachmentSnapshot
  }
}
    ${CrmContactPersonFragmentDoc}
${AttachmentSnapshotFragmentDoc}`;
export const CreateCrmCompanyDocument = gql`
    mutation CreateCrmCompany($input: CreateCrmCompanyInput!) {
  createCrmCompany(input: $input) {
    crmCompany {
      id
      ...CreateCrmCompany_CrmCompany
    }
  }
}
    ${CreateCrmCompany_CrmCompanyFragmentDoc}`;
export type CreateCrmCompanyMutationFn = Apollo.MutationFunction<CreateCrmCompanyMutation, CreateCrmCompanyMutationVariables>;

/**
 * __useCreateCrmCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCrmCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCrmCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCrmCompanyMutation, { data, loading, error }] = useCreateCrmCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCrmCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCrmCompanyMutation, CreateCrmCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCrmCompanyMutation, CreateCrmCompanyMutationVariables>(CreateCrmCompanyDocument, options);
      }
export type CreateCrmCompanyMutationHookResult = ReturnType<typeof useCreateCrmCompanyMutation>;
export type CreateCrmCompanyMutationResult = Apollo.MutationResult<CreateCrmCompanyMutation>;
export type CreateCrmCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCrmCompanyMutation, CreateCrmCompanyMutationVariables>;
export const CreateCrmCompanyAsIndividualDocument = gql`
    mutation CreateCrmCompanyAsIndividual($input: CreateCrmCompanyAsIndividualInput!) {
  createCrmCompanyAsIndividual(input: $input) {
    crmCompany {
      id
      ...CreateCrmCompany_CrmCompany
    }
  }
}
    ${CreateCrmCompany_CrmCompanyFragmentDoc}`;
export type CreateCrmCompanyAsIndividualMutationFn = Apollo.MutationFunction<CreateCrmCompanyAsIndividualMutation, CreateCrmCompanyAsIndividualMutationVariables>;

/**
 * __useCreateCrmCompanyAsIndividualMutation__
 *
 * To run a mutation, you first call `useCreateCrmCompanyAsIndividualMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCrmCompanyAsIndividualMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCrmCompanyAsIndividualMutation, { data, loading, error }] = useCreateCrmCompanyAsIndividualMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCrmCompanyAsIndividualMutation(baseOptions?: Apollo.MutationHookOptions<CreateCrmCompanyAsIndividualMutation, CreateCrmCompanyAsIndividualMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCrmCompanyAsIndividualMutation, CreateCrmCompanyAsIndividualMutationVariables>(CreateCrmCompanyAsIndividualDocument, options);
      }
export type CreateCrmCompanyAsIndividualMutationHookResult = ReturnType<typeof useCreateCrmCompanyAsIndividualMutation>;
export type CreateCrmCompanyAsIndividualMutationResult = Apollo.MutationResult<CreateCrmCompanyAsIndividualMutation>;
export type CreateCrmCompanyAsIndividualMutationOptions = Apollo.BaseMutationOptions<CreateCrmCompanyAsIndividualMutation, CreateCrmCompanyAsIndividualMutationVariables>;
export const ModifyCrmOrganisationDocument = gql`
    mutation ModifyCrmOrganisation($organisations: [CrmOrganisationModifyInput!]!) {
  modifyCrmOrganisation(input: $organisations) {
    crmOrganisations {
      id
      ...OrganisationRouter__CrmCompany
    }
  }
}
    ${OrganisationRouter__CrmCompanyFragmentDoc}`;
export type ModifyCrmOrganisationMutationFn = Apollo.MutationFunction<ModifyCrmOrganisationMutation, ModifyCrmOrganisationMutationVariables>;

/**
 * __useModifyCrmOrganisationMutation__
 *
 * To run a mutation, you first call `useModifyCrmOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyCrmOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyCrmOrganisationMutation, { data, loading, error }] = useModifyCrmOrganisationMutation({
 *   variables: {
 *      organisations: // value for 'organisations'
 *   },
 * });
 */
export function useModifyCrmOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<ModifyCrmOrganisationMutation, ModifyCrmOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyCrmOrganisationMutation, ModifyCrmOrganisationMutationVariables>(ModifyCrmOrganisationDocument, options);
      }
export type ModifyCrmOrganisationMutationHookResult = ReturnType<typeof useModifyCrmOrganisationMutation>;
export type ModifyCrmOrganisationMutationResult = Apollo.MutationResult<ModifyCrmOrganisationMutation>;
export type ModifyCrmOrganisationMutationOptions = Apollo.BaseMutationOptions<ModifyCrmOrganisationMutation, ModifyCrmOrganisationMutationVariables>;